import React, { Component } from "react";
import InputField from "./Elements/InputField";
import SubmitFeed from "./Elements/SubmitFeed";


class PinterestFeed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userBoard: "",
            handle: "",
            error: false,
            handleError: false,
            loading: false,
            errorMsg: "This field is required"
        }
    }

    onTextChange = (e) => this.setState({ [e.target.name]: e.target.value, error: false, handleError:false });

    onSubmit = () => {
        const { updateStep, selectedFilterId } = this.props;
        const { userBoard, handle } = this.state;
        if (selectedFilterId == 1 && handle.trim().length == 0) {
            this.setState({ handleError: true });
        } else if (selectedFilterId == 12 && userBoard.trim().length ==0 ) {
            this.setState({ error: true, errorMsg: "This field is required" });
        } else {

            var obj = {
                networkId: 5,
                moderation: 0,
                connetedAccount: 0,
                feedType: selectedFilterId,
                filter: selectedFilterId
            }

            if (selectedFilterId == 1) {
                obj['field1'] = handle.split('@').join('');
            } else if (selectedFilterId == 12) {
                obj['field12boardurl'] = userBoard;

                if (userBoard.includes('pinterest.com')) {
                    let boardUrl = userBoard.replace('www.pinterest.com','in.pinterest.com');
                    let url = boardUrl.split("https://in.pinterest.com/")[1].replace("/", "");
                    if (url) {
                        obj['field1'] = url;
                    } else {
                        this.setState({ errorMsg: 'This field must contain a url', error: true })
                        return false;
                    }
                } else {
                    this.setState({ errorMsg: 'This field must contain a url', error: true })
                    return false;
                }
            }
            
            this.setState({ error: false, handleError: false, loading: true });

            updateStep(2, obj, () => this.setState({ loading: false }));
        }
    }

    render() {
        const { userBoard, handle, error, handleError, loading, errorMsg } = this.state;
        const { selectedFilterId } = this.props;
        
        return (
            <div className="ob-feed-form-wrapper w-100">
                {selectedFilterId == 12 ? <div className="selectSource-right mb-3">
                    <div className="position-relative d-flex custom-input">
                        <span className="hastag d-flex align-items-center">
                            <i className={`fas fa-flag`}></i>
                        </span>
                        <InputField name={"userBoard"} placeholder="Enter board URL here.." className="form-control p-3" value={userBoard} onChangeHandler={(e) => this.onTextChange(e)} />
                    </div>
                    {error && <span id="feedsslackkeyworderror" className="errorMessage required text-start">{errorMsg}</span>}
                </div> :
                    <div className="selectSource-right mb-3">
                        <div className="position-relative d-flex custom-input">
                            <span className="hastag d-flex align-items-center">
                               <i className={`fas fa-at`}></i>
                            </span>
                            <InputField name={"handle"} placeholder="Enter handle here.." className="form-control p-3" value={handle} onChangeHandler={(e) => this.onTextChange(e)} />
                        </div>
                        {handleError && <span id="feedsslackkeyworderror" className="errorMessage required text-start">This field is required</span>}
                    </div>}
                <div className="click-next d-flex align-items-center py-3 px-4 rounded justify-content-between">
                    <SubmitFeed loading={loading} onSubmit={this.onSubmit} onBack={this.props.backAction} disabled={selectedFilterId == 12 ? !userBoard.trim() : !handle.trim()} />
                </div> 
            </div>
        )
    }
}

export default PinterestFeed;